import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/sections/Footer';
import { Cart } from '@/components/store/Cart';
import { useCart } from '@/contexts/CartContext';
import { SEO } from '@/components/SEO';
import { SkipLink } from '@/components/SkipLink';

const Carrello = () => {
  const { items, updateQuantity, removeFromCart, clearCart } = useCart();

  // Debug: verifica che gli items siano caricati
  if (import.meta.env.DEV) {
    console.log('Carrello - Items:', items);
    console.log('Carrello - Items count:', items.length);
  }

  return (
    <>
      <SkipLink />
      <main id="main-content" className="min-h-screen bg-background">
        <SEO
          title="Carrello - Brace e Sapori Store"
          description="Rivedi i prodotti nel tuo carrello e procedi con l'ordine. Modifica quantità, rimuovi prodotti e completa il tuo acquisto."
          keywords="carrello, checkout, ordine online, brace e sapori"
          noindex={true}
        />
        <Header />
        
        <div className="pt-24 pb-16 px-4 md:px-6">
          <div className="mx-auto max-w-4xl">
            <Cart
              items={items}
              onUpdateQuantity={updateQuantity}
              onRemoveItem={removeFromCart}
              onClearCart={clearCart}
            />
          </div>
        </div>

        <Footer />
      </main>
    </>
  );
};

export default Carrello;

